import colors from "@digits-shared/themes/colors"
import styled, { css } from "styled-components"

export const WIDGET_PADDING = 15

export const WIDGET_CONTAINER_STYLES = css`
  position: relative;
  padding: ${WIDGET_PADDING}px;
  border-radius: 16px;
  background: ${colors.white90};
  color: ${colors.secondary};
`

export const WidgetContainer = styled.div`
  ${WIDGET_CONTAINER_STYLES};
`

export const WIDE_WIDGET_PADDING = 25

export const WideWidgetContainer = styled(WidgetContainer)`
  padding: ${WIDE_WIDGET_PADDING}px;

  & + & {
    margin-top: 15px;
  }
`

export const WideWidgetTopContainer = styled(WidgetContainer)`
  padding: ${WIDE_WIDGET_PADDING}px;
  border-radius: 16px;
  margin-bottom: 16px;

  .mobile & {
    margin-top: 0;
    padding: 18px;
  }
`
